'use strict';

var _ = require('lodash');
var StrategyMqSposSeasonDowGrp = function StrategyMqSposSeasonDowGrp(strategyHelper) {
  function getLabel(season, dowGroup) {
    return _.capitalize(season) + ', ' + dowGroup;
  }
  function getProfileLevel() {
    return 'MQ_SPOS_S_DOWG';
  }
  function condition(quickFilterData, season, dowGroup) {
    return _.isArray(quickFilterData.seasons) && quickFilterData.seasons.indexOf(season) !== -1 && _.isArray(quickFilterData.dows) && quickFilterData.dows.indexOf(dowGroup) !== -1;
  }
  function profileMatched(quickFilterData, season, dowGroup) {
    return condition(quickFilterData, season, dowGroup);
  }
  function getFillData(quickFilterData, season, dowGroup) {
    return strategyHelper.getFillData(quickFilterData, season, dowGroup, condition);
  }
  return {
    getLabel: getLabel,
    getFillData: getFillData,
    profileMatched: profileMatched,
    getProfileLevel: getProfileLevel
  };
};
StrategyMqSposSeasonDowGrp.$inject = ['StrategyHelper'];
module.exports = StrategyMqSposSeasonDowGrp;